import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import "./VerifyEmail.css";

export default function VerifyEmail({ translations }) {
    let navigate = useNavigate();
    const location = useLocation();
    const { refreshProfile } = useAuth();
    const email = location.state?.email || '';
    const params = new URLSearchParams(location.search);
    const [code, setCode] = useState(params.get('token') || '');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const data = await api.confirmRegistration(code);
            api.setToken(data.token);
            await refreshProfile();
            navigate('/');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="background-modal"></div>
            <div className="content">
                <h2>{translations['verify-email-title']}</h2>
                <p className='description'>
                    {email
                        ? <> {translations['verify-email-description']} <strong>{email}</strong></>
                        : translations['verify-email-code']
                    }
                </p>
                <input
                    type="text"
                    placeholder={translations['verify-email-code-placeholder']}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className='input-text'
                />
                {error && <p className="error-text">{error}</p>}
                <button className='btn center' onClick={handleSubmit} disabled={loading}>
                    {loading ? <span className="spinner" /> : translations['verify-email-button']}
                </button>
                <div id="confirmEmailResult"></div>
            </div>
        </>
    );
}
